import { store } from '@/app/store';
import { logout, setTokens } from '@/entities/authSlice';
import { refreshTokens } from './refresh';

interface FetcherOptions extends RequestInit {
  params?: Record<string, string | number | boolean>;
}

export async function fetcher(
  endpoint: string,
  options: FetcherOptions = {}
): Promise<Response> {
  const url = new URL(`${import.meta.env.VITE_API_URL}/exec/api${endpoint}`);

  if (options.params) {
    Object.entries(options.params).forEach(([key, value]) =>
      url.searchParams.append(key, String(value))
    );
  }

  const send = (token: string | null) => {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    return fetch(url.toString(), {
      ...options,
      headers: {
        ...headers,
        ...options.headers,
      },
    });
  };

  let response = await send(store.getState().auth.token);

  if (response.status === 401) {
    const refreshToken = store.getState().auth.refreshToken;
    const tokens = refreshToken ? await refreshTokens(refreshToken) : null;

    if (tokens) {
      store.dispatch(setTokens(tokens));
      response = await send(tokens.token);
    } else if (refreshToken) {
      store.dispatch(logout());
    }
  }

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Ошибка ${response.status}: ${errorText}`);
  }

  return response;
}
